import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Text, Inline, IconChevron } from "braid-design-system";
import { useState } from "react";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { ResponsiveTab } from "../ResponsiveTab/ResponsiveTab.mjs";
import { link } from "./ExpandableTab.css.mjs";
const ExpandableTab = ({
  text,
  child,
  isExpanded = false,
  linkContext,
  Icon,
  shouldApplyIconForActiveItem
}) => {
  const { sendLinkEvent } = useLink();
  const [isMenuOpen, setIsOpen] = useState(isExpanded);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "button",
        display: "block",
        width: "full",
        paddingX: "small",
        className: link,
        cursor: "pointer",
        onClick: () => {
          setIsOpen(!isMenuOpen);
          sendLinkEvent({
            linkContext: {
              ...linkContext,
              openingOrClosing: isMenuOpen ? "closing" : "opening"
            }
          });
        },
        "data-automation": linkContext.source,
        "aria-expanded": isMenuOpen,
        children: /* @__PURE__ */ jsx(Box, { paddingY: "medium", children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsxs(
          Box,
          {
            alignItems: "center",
            display: "flex",
            justifyContent: "spaceBetween",
            children: [
              /* @__PURE__ */ jsxs(Inline, { alignY: "center", align: "left", space: "xxsmall", children: [
                Icon && /* @__PURE__ */ jsx(Icon, { alignY: "lowercase" }),
                /* @__PURE__ */ jsx(Fragment, { children: text })
              ] }),
              /* @__PURE__ */ jsx(
                IconChevron,
                {
                  alignY: "lowercase",
                  direction: isMenuOpen ? "up" : "down"
                }
              )
            ]
          }
        ) }) }, `ResponsiveTab-${text}`)
      }
    ),
    child.map((tabItem, index) => /* @__PURE__ */ jsx(
      ResponsiveTab,
      {
        isMenuOpen,
        isSubItem: true,
        tabItem,
        shouldApplyIconForActiveItem
      },
      index
    ))
  ] });
};
export {
  ExpandableTab
};
